<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'

export default {
  name: 'UserSourceStat',
  props: {
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '分布'
        },
        xAxis: {
          name: '来源',
          type: 'category',
          data: [],
          axisLabel: {
            rotate: 45 // 标签旋转45度
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [{
          name: '',
          data: [],
          barWidth: '50%',
          type: 'bar',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          }, itemStyle: {
            normal: {
              color: '#87CEFA'
            }
          }
        }]
      }
    },
    refresh(data) {
      const time = []
      const value = []
      for (const i in data) {
        time.push(data[i].ridStr)
        value.push(data[i].num)
      }
      this.option.xAxis.data = time
      this.option.series[0].data = value
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
